const React = require('react');
const Radio = require('./../../../radio_input');

class Welcome extends React.Component {

  handleChange (event) {
    this.props.onChange('has_status_page', event.target.value);
  }

  contextText () {
    if (this.props.has_status_page === 'customer') {
      return 'Great news! As a Statuspage customer, your error pages will include a javascript snippet that pulls in information from your status page via the API.';
    } else if (this.props.has_status_page === 'non-customer') {
      return "Cool! We'll be able to include links to your status page on your error pages.";
    }
    if (this.props.has_status_page === 'no') {
      return (
        <span>
          Need a status page? <a href="https://www.statuspage.io" target="_blank">We can help you with that.</a>.
        </span>
      );
    }
  }

  render () {
    const values = [
      { label: 'Yes I have a status page AND I\'m a Statuspage  customer.', value: 'customer' },
      { label: 'Yes I have a status page BUT I\'m not a Statuspage customer.', value: 'non-customer' },
      { label: 'No, I don\'t have a status page.', value: 'no' },
    ];
    return (
      <div className="step-container step-one">
        <div>
          <h2>First off, do you have a status page?</h2>

          <p>We need to know if your company has a status page because if you do, we'll include a link to it on your error pages.</p>
          <div className="controls">
            {values.map((value, index) => (
              <Radio
                key={index}
                label={value.label}
                value={value.value}
                name={'has-status-page'}
                checked={value.value === this.props.has_status_page}
                onChange={this.handleChange.bind(this)} />
              ))}
          </div>
          <small>
            {this.contextText()}
          </small>
        </div>
      </div>
    );
  }

}

module.exports = Welcome;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/better_error_pages/walk_through/questions/have_status_page.jsx